import type { ReactNode } from 'react';
import { Link } from '@mui/material';

import type { AdModel } from '@/types';
import { RentPeriodEnum } from '@/types';
import { priceFormat } from '@/utils';

import styles from './AdsListItem.module.scss';
import ItemBaths from './svg/itemBaths.svg';
import ItemBed from './svg/itemBed.svg';
import ItemFee from './svg/itemFee.svg';
import ItemGps from './svg/itemGps.svg';
import ItemSqft from './svg/itemSqft.svg';

interface AdsListItemMainInfoProps {
  address: string;
  area: number;
  baths: AdModel['baths'];
  beds: AdModel['beds'];
  children: ReactNode;
  convertedAreaUnits: string;
  convertedCurrency: AdModel['convertedCurrency'];
  defaultRentFrequency: AdModel['defaultRentFrequency'];
  filterRentFrequency?: RentPeriodEnum;
  id: string;
  isNotCommercial: boolean;
  isSale: boolean;
  multilistingText?: string;
  price: number;
  rentFrequencyLabels: Record<RentPeriodEnum, string>;
  textBaths: string;
  textBeds: string;
  title: string;
  titleText: string;
}

export const AdsListItemMainInfo = ({
  address,
  area,
  baths,
  beds,
  children,
  convertedAreaUnits,
  convertedCurrency,
  defaultRentFrequency,
  filterRentFrequency,
  id,
  isNotCommercial,
  isSale,
  multilistingText,
  price,
  rentFrequencyLabels,
  textBaths,
  textBeds,
  title,
  titleText,
}: AdsListItemMainInfoProps) => (
  <div className={styles.itemContent}>
    <Link href={`/ads/${id}`} title={title} className={styles.itemName}>
      {titleText}
    </Link>
    <div className={styles.itemPriceContainer}>
      <div className={styles.itemPrice}>
        Price <span>{priceFormat(price)}</span> {convertedCurrency}
        {!isSale && defaultRentFrequency && (
          <div className={styles.itemLabel}>
            {rentFrequencyLabels[filterRentFrequency || defaultRentFrequency]}
          </div>
        )}
      </div>
      <div className={styles.itemFee}>
        <img src={ItemFee} alt='' />
        {multilistingText}
      </div>
    </div>
    <div className={styles.itemAddress}>
      <img src={ItemGps} alt='' />
      {address}
    </div>
    <div className={styles.itemParams}>
      {area > 0 && (
        <div>
          <img src={ItemSqft} alt='' />
          {area} {convertedAreaUnits.toLowerCase()}
        </div>
      )}
      {isNotCommercial && (
        <>
          {beds && (
            <>
              <div className={styles.itemParamsSeparator} />
              <div>
                <img src={ItemBed} alt='' />
                {`${beds} ${textBeds}`}
              </div>
            </>
          )}
          {baths && (
            <>
              <div className={styles.itemParamsSeparator} />
              <div>
                <img src={ItemBaths} alt='' />
                {`${baths} ${textBaths}`}
              </div>
            </>
          )}
        </>
      )}
    </div>
    {children}
  </div>
);
